var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',_vm._b({staticClass:"check",attrs:{"true-label":1,"false-label":0},on:{"input":function($event){return _vm.change($event)}}},'el-checkbox',_vm.$attrs,false),[_vm._v("\n  乙方可调1\n")])}
var staticRenderFns = []

export { render, staticRenderFns }